module.exports = "<div class=\"container\">\n  <app-quiz></app-quiz>\n</div>"